import { cn } from "../../lib/utils"
import { Button } from "../ui/button"
import { Link, useLocation } from "react-router-dom"
import { ROLES } from "@/common/permissions"
import { useIsPermitted } from "@/hooks/useIsPermitted"
export interface NavItemProps {
  to: string
  label: string
  className?: string
  role?: ROLES
}

export function NavItem({ to, label, className, role }: NavItemProps) {
  const location = useLocation();
  const isActive = location.pathname === to;
  const isPermitted = useIsPermitted(role || ROLES.WAITER);

const Content = () => (
  <span
    className={cn(
      "text-xs font-medium text-dark-foreground",
      isActive && "font-semibold"
    )}
  >
    {label}
  </span>
);

  if (!isPermitted) {
    return null;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(isActive && "bg-dark-foreground/10", className)}
      asChild={isPermitted}
      disabled={!isPermitted}
    >
      {isPermitted ? (
        <Link to={to}>
          <Content />
        </Link>
      ) : (
        <Content />
      )}
    </Button>
  );
} 